import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/user'
import { translate } from '@/i18n'

const request = axios.create({
  baseURL: '/api',
  timeout: 10000
})

// Request Interceptor
request.interceptors.request.use(
  (config) => {
    const userStore = useUserStore()
    if (userStore.token) {
      config.headers.Authorization = `Bearer ${userStore.token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response Interceptor
request.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code !== 200) {
      ElMessage.error(res.message || translate('common.error'))
      return Promise.reject(new Error(res.message))
    }
    return res.data
  },
  (error) => {
    const { response } = error
    if (response?.status === 401) {
      const userStore = useUserStore()
      // 令牌超时：带上邮箱跳转登录页，登录页会自动重发验证码
      const email = userStore.userInfo?.email || localStorage.getItem('loginEmail') || ''
      userStore.logout()
      const query = email ? `?expired=1&email=${encodeURIComponent(email)}` : '?expired=1'
      window.location.href = '/login' + query
      return Promise.reject(error)
    }
    // 413：请求体超限（通常是反代 body 限制），给出友好提示而不是原始状态码
    if (response?.status === 413) {
      ElMessage.error(translate('common.requestTooLarge', { n: 5 }))
      return Promise.reject(error)
    }
    ElMessage.error(error.message || translate('common.requestError'))
    return Promise.reject(error)
  }
)

export default request
